<yasc-dialog headerKey="{{ 'quickInputHead'|translate:locale.language }}" (cancelClicked)="dialogRef.close()" [disableSave]="quickGroup.invalid" (saveClicked)="saveQuickInput()">
        <div mat-dialog-content class="fastInputDialogLayout">
            <mat-form-field style="align-self: end" [formGroup]="quickGroup">
                <mat-label>{{ 'generalDate'|translate:locale.language }}</mat-label>
                <input matInput
                       [required]="true"
                       formControlName="date"
                       [matDatepicker]="picker">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <label>{{ 'generalCompany'|translate:locale.language }}</label>
            <div>
                <mat-form-field style="flex-grow: 1" [formGroup]="quickGroup">
                    <mat-label>{{ 'companyCreateSetName'|translate:locale.language }}</mat-label>
                    <input type="text"
                           matInput
                           formControlName="company"
                           [matAutocomplete]="companyNameAuto"
                           [required]="true">
                    <mat-icon matIconSuffix
                              matTooltip="{{showCheck('company')|translate:locale.language}}">{{ showCheck('company') }}
                    </mat-icon>

                    <mat-autocomplete #companyNameAuto [displayWith]="companyDisplayFn">
                        <mat-option *ngFor="let company of filteredCompanies|async"
                                    [value]="company.company">
                            {{ company.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>


                <mat-form-field style="flex-grow: 1" [formGroup]="quickGroup">
                    <mat-label>{{ 'commDetailTypeInput'|translate:locale.language }}</mat-label>
                    <mat-select formControlName="type" required>
                        <mat-option *ngFor="let item of types|enumConvert"
                                    [value]="item.value">{{ item.name|translate:locale.language }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <label>{{ 'ContactDetailHeader'|translate:locale.language }}</label>
            <div>
                <mat-form-field [formGroup]="quickGroup">
                    <mat-label>{{ 'generalPronouns'|translate:locale.language }}</mat-label>
                    <mat-select formControlName="pronoun">
                        <mat-option *ngFor="let item of pronouns| enumConvert" [value]="item.value">
                            {{ item.name | translate:locale.language }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field style="flex-grow: 3" [formGroup]="quickGroup">
                    <mat-label>{{ 'generalLastName'|translate:locale.language }}</mat-label>
                    <input type="text"
                           matInput
                           [required]="true"
                           formControlName="lastName"
                           [matAutocomplete]="contactNameAuto">
                    <mat-icon matIconSuffix
                              matTooltip="{{showCheck('lastName')|translate:locale.language}}">{{ showCheck('lastName') }}
                    </mat-icon>
                    <mat-autocomplete #contactNameAuto [displayWith]="contactDisplayFn">
                        <mat-optgroup *ngFor="let group of filteredContacts|async" [label]="group.company">
                            <mat-option *ngFor="let contact of group.contacts | keyvalue" [value]="contact.value">
                                {{ contact.key }}
                            </mat-option>
                        </mat-optgroup>
                    </mat-autocomplete>
                </mat-form-field>
            </div>


            <div>
                <mat-form-field [formGroup]="quickGroup" style="flex-grow: 1">
                    <mat-label>{{ 'generalEMail'|translate:locale.language }}</mat-label>
                    <input type="mail"
                           matInput
                           formControlName="mail">
                    <mat-hint></mat-hint>
                </mat-form-field>

                <mat-form-field [formGroup]="quickGroup" style="flex-grow: 1">
                    <mat-label>{{ 'generalPhone'|translate:locale.language }}</mat-label>
                    <input type="tel"
                           [required]="true"
                           matInput
                           formControlName="phone">
                    <mat-hint></mat-hint>
                </mat-form-field>
            </div>

            <div style="display: grid; grid-template-columns: 1fr auto">
                <div style="display: flex; flex-direction: column">
                    <label>{{ 'generalNote'|translate:locale.language }}</label>
                    <mat-form-field [formGroup]="quickGroup">
                        <mat-label>{{ 'quickInputTextTitle'|translate:locale.language }}</mat-label>
                        <input type="text"
                               matInput
                               [required]="true"
                               formControlName="title">
                        <mat-hint></mat-hint>
                    </mat-form-field>
                    <mat-form-field [formGroup]="quickGroup">
                        <mat-label>{{ 'quickInputText'|translate:locale.language }}</mat-label>
                        <textarea matInput
                                  formControlName="text"
                                  style="resize: none; height: 18vh">
                        </textarea>
                    </mat-form-field>
                </div>
                <div style="display: flex;flex-direction: column">
                    <yasc-file-upload
                            yascLabel="Anhang"
                            (filesChange)="uploadAttachment($event)"
                            [yascAllowMultiUpload]="true"
                            style="width: 200px; height: 200px">
                    </yasc-file-upload>
                    <cp-attachment-item *ngFor="let item of uploadedFiles" [fileUpload]="item" usageType="add"
                                        (remove)="removeUpload(item)"></cp-attachment-item>
                </div>
            </div>
        </div>
</yasc-dialog>
